import gql from 'graphql-tag';

export const accountSubscriptionFragment = gql`
  fragment accountSubscriptionFragment on AccountSubscription {
    dokkioClass
    id
    subscriptionDuration
    willSubscriptionRenew
  }
`;
export default accountSubscriptionFragment;
